module.exports = __webpack_public_path__ + "img/Card 1.e82edaf8.png";